import { mutateQueryString } from '@repositories/utils/dataFetching/apolloFetcher';

export const resendActivationEmail = <D>(data: D) =>
  mutateQueryString(`mutation ResendActivationEmail($email: String!, $langcode: String!) {
    resendActivationEmail(email: $email, langcode: $langcode)
  }`)(data);
